import store from '../store'

export default function localize(key) {
    return store.getters.localize(key)
}